import { ACTIONS } from '../constants/actionTypes';

function offerReducer(state = {}, action) {
  switch (action.type) {
    case ACTIONS.FETCH_COUPON_VOUCHER_OFFERS:
      return { ...state, couponAndVouchers: action.payload };
    case ACTIONS.FETCH_BANK_OFFERS:
      return { ...state, bankOffers: action.payload };
    default:
      return state;
  }
}

export default offerReducer;
